import {
  ActionIcon,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  MultiSelect,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { useDebouncedState, useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBuildingCastle,
  IconBuildingCommunity,
  IconDirections,
  IconPlus,
  IconSearch,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import { repositoryMdm } from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { changeSearchValue } from "../../../_base/helper/FunctionHelper";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  getCommuneSelectNew,
  getProvinceSelect,
  getProvinceSelectNew,
} from "../../../service/getSelectApi";
import CreateAddressConversion from "./CreateAddressConversion";

const AddressConversion = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const [search, setSearch] = useState<any>({});
  console.log(search);
  const [keySearch, setKeySearch] = useDebouncedState<string>("", 300);

  const [dataProvinceSelect, setDataProvinceSelect] = useState<ComboboxItem[]>(
    []
  );
  const [dataDistrictSelect, setDataDistrictSelect] = useState<ComboboxItem[]>(
    []
  );
  const [dataCommuneSelect, setDataCommuneSelect] = useState<ComboboxItem[]>(
    []
  );
  const [dataProvinceNewSelect, setDataProvinceNewSelect] = useState<
    ComboboxItem[]
  >([]);
  const [dataCommuneNewSelect, setDataCommuneNewSelect] = useState<
    ComboboxItem[]
  >([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "1",
        header: "Địa chỉ (Trước khi sáp nhập tỉnh)",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {row.original.name} - {row.original.districtName} -{" "}
            {row.original.provinceName}
          </Text>
        ),
      },
      {
        accessorKey: "2",
        header: "Địa chỉ mới (Sau khi sáp nhập tỉnh)",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {`${
              row.original.newCommuneName ? row.original.newCommuneName : ""
            } ${
              row.original.newProvinceName &&
              row.original.newProvinceName?.length > 0
                ? "- " + row.original.newProvinceName
                : ""
            }`}
          </Text>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableColumnFilter: false,
        enableColumnActions: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <Flex justify={"start"} gap={"xs"}>
            <Tooltip label="Gán địa chỉ chuyển đổi">
              <ActionIcon
                variant="light"
                color="teal"
                onClick={() => modalsCreate(row.original)}
              >
                <IconPlus size={16} />
              </ActionIcon>
            </Tooltip>
          </Flex>
        ),
      },
    ],
    []
  );

  const modalsCreate = (data: any) => {
    modals.openConfirmModal({
      title: <Title order={5}>Tạo mới địa chỉ chuyển đổi</Title>,
      size: "auto",
      children: <CreateAddressConversion onSuccess={fetchData} data={data} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/TblDmCommune/get-list?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      url += `&${params.toString()}`;

      const res = await repositoryMdm.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  //   const handleExportExcel = async () => {
  //     open();
  //     try {
  //       let url = `/api/v1/PriceList/export-excel?Skip=${
  //         pagination.pageIndex * pagination.pageSize
  //       }&Take=${pagination.pageSize}`;

  //       const params = new URLSearchParams();
  //       Object.entries(search).forEach(([key, value]) => {
  //         if (Array.isArray(value) && value.length > 0) {
  //           value.forEach((item) => params.append(key, String(item)));
  //         } else if (typeof value === "string" && value.length > 0) {
  //           params.append(key, value);
  //         }
  //       });

  //       if (keySearch.length > 0) {
  //         url += `&KeySearch=${keySearch}`;
  //       }

  //       url += `&${params.toString()}`;

  //       const _url = BASE_API_DELIVERY + url;
  //       const token = localStorage.getItem("token");

  //       const response = await fetch(_url, {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/vnd.ms-excel",
  //           Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
  //         },
  //       });

  //       if (!response.ok) {
  //         NotificationExtension.Fails("Export Excel thất bại !");
  //       } else {
  //         NotificationExtension.Success("Export Excel thành công !");
  //         const blob = await response.blob();
  //         const urlss = window.URL.createObjectURL(blob);
  //         const _name = new Date().toISOString().slice(0, 10);
  //         let filename = "bao_cao_bang_gia" + _name + ".xlsx";
  //         const link = document.createElement("a");
  //         link.href = urlss;
  //         link.download = filename;
  //         document.body.appendChild(link);
  //         link.click();
  //         link.remove();
  //         window.URL.revokeObjectURL(url);
  //       }
  //     } catch (error) {
  //       console.error("Error:", error);
  //     } finally {
  //       close();
  //     }
  //   };

  const fetchDataProvince = async () => {
    const res = await getProvinceSelect();

    if (res) {
      const data = res
        ?.filter((item: any) => item.text && item.value)
        ?.map((item: any) => ({
          label: String(item.text),
          value: String(item.value),
        }));
      setDataProvinceSelect(data);
    }
  };

  const fetchDataDistrict = async (listProvinceId: any[]) => {
    const dataSearch =
      Array.isArray(listProvinceId) && listProvinceId.length > 0
        ? listProvinceId.map((item) => `&ProvinceIds=${item}`).join("")
        : "";

    const res = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblDmDistrict/get-list?Skip=0&Take=${
        listProvinceId.length * 30
      }${dataSearch}`
    );

    if (res && res.success) {
      const result = res.data;
      const data = result
        ?.filter((item: any) => item.name && item.id)
        ?.map((item: any) => ({
          label: String(item.name),
          value: String(item.id),
        }));
      setDataDistrictSelect(data);
    }
  };

  const fetchDataCommune = async (listDistrict: any[]) => {
    const dataSearch =
      Array.isArray(listDistrict) && listDistrict.length > 0
        ? listDistrict.map((item) => `&DistrictIds=${item}`).join("")
        : "";

    const res = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblDmCommune/get-list?Skip=0&Take=${
        listDistrict.length * 30
      }${dataSearch}`
    );

    if (res && res.success) {
      const result = res.data;
      const data = result
        ?.filter((item: any) => item.id && item.name)
        ?.map((item: any) => ({
          label: String(item.name),
          value: String(item.id),
        }));
      setDataCommuneSelect(data);
    }
  };

  const fetchDataProvinceNew = async () => {
    const res = await getProvinceSelectNew();

    if (res) {
      setDataProvinceNewSelect(
        res
          ?.filter((item) => item.id && item.name)
          ?.map((item) => ({
            value: String(item.id),
            label: String(item.name),
          }))
      );
    }
  };

  const fetchDataCommuneNew = async (listId: string) => {
    const dataSearch =
      Array.isArray(listId) && listId.length > 0
        ? listId.map((item) => `&ProvinceIds=${item}`).join("")
        : "";

    const res = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblDmCommuneMoi/get-select?Active=true${dataSearch}`
    );

    if (res && res.success) {
      const result = res.data;
      setDataCommuneNewSelect(
        result
          ?.filter((item: any) => item.text && item.value)
          ?.map((item: any) => ({
            value: String(item.value),
            label: String(item.text),
          }))
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination]);

  useEffect(() => {
    fetchDataProvince();
    fetchDataProvinceNew();
  }, []);

  useEffect(() => {
    if (Array.isArray(search?.ProvinceIds) && search?.ProvinceIds.length > 0) {
      fetchDataDistrict(search?.ProvinceIds);
    } else {
      setDataDistrictSelect([]);
    }
  }, [search.ProvinceIds]);

  useEffect(() => {
    if (
      Array.isArray(search?.NewProvinceIds) &&
      search?.NewProvinceIds.length > 0
    ) {
      fetchDataCommuneNew(search?.NewProvinceIds);
    } else {
      setDataCommuneNewSelect([]);
    }
  }, [search?.NewProvinceIds]);

  useEffect(() => {
    if (Array.isArray(search?.DistrictIds) && search?.DistrictIds.length > 0) {
      fetchDataCommune(search?.DistrictIds);
    } else {
      setDataCommuneSelect([]);
    }
  }, [search?.DistrictIds]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (185 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: [],
        right: [],
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["50", "100", "200"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Flex justify={"end"} gap={"xs"}>
            {/* <Button
              leftSection={<IconFileExport size={14} />}
              onClick={() => handleExportExcel()}
            >
              Export Excel
            </Button> */}
            {/* <Button
              leftSection={<IconPlus size={16} />}
              color="teal"
              onClick={() => modalsCreate()}
            >
              Tạo mới
            </Button> */}
          </Flex>
        </Flex>
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa tìm kiếm"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Tỉnh/TP (Trước sáp nhập)"
              data={dataProvinceSelect}
              clearable
              searchable
              leftSection={<IconBuildingCastle color="#15aabf" />}
              onChange={(e) => {
                changeSearchValue(e ? e : "", "ProvinceIds", setSearch);
                changeSearchValue([], "DistrictIds", setSearch);
                changeSearchValue([], "Ids", setSearch);
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Quận/Huyện (Trước sáp nhập)"
              data={dataDistrictSelect}
              value={
                search?.DistrictIds && search?.DistrictIds?.length > 0
                  ? search?.DistrictIds
                  : []
              }
              clearable
              searchable
              leftSection={<IconBuildingCommunity color="#15aabf" />}
              onChange={(e) => {
                changeSearchValue(e ? e : "", "DistrictIds", setSearch);
                changeSearchValue([], "Ids", setSearch);
              }}
              nothingFoundMessage={
                search?.ProvinceIds && search?.ProvinceIds?.length > 0
                  ? "Không tìm thấy dữ liệu !"
                  : "Vui lòng chọn tỉnh/thành phố !"
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Phường/Xã (Trước sáp nhập)"
              data={dataCommuneSelect}
              value={search?.Ids && search?.Ids?.length > 0 ? search?.Ids : []}
              clearable
              searchable
              leftSection={<IconDirections color="#15aabf" />}
              onChange={(e) => changeSearchValue(e ? e : "", "Ids", setSearch)}
              nothingFoundMessage={
                search?.DistrictIds && search?.DistrictIds?.length > 0
                  ? "Không tìm thấy dữ liệu !"
                  : "Vui lòng chọn quận/huyện !"
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Tỉnh/TP (Sau sáp nhập)"
              data={dataProvinceNewSelect}
              clearable
              searchable
              leftSection={<IconBuildingCastle color="#15aabf" />}
              onChange={(e) => {
                changeSearchValue(e ? e : "", "NewProvinceIds", setSearch);
                changeSearchValue([], "NewCommuneIds", setSearch);
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Phường/Xã (Sau sáp nhập)"
              data={dataCommuneNewSelect}
              value={
                search?.NewCommuneIds && search?.NewCommuneIds?.length > 0
                  ? search?.NewCommuneIds
                  : []
              }
              clearable
              searchable
              leftSection={<IconDirections color="#15aabf" />}
              onChange={(e) =>
                changeSearchValue(e ? e : "", "NewCommuneIds", setSearch)
              }
              nothingFoundMessage={
                search?.NewProvinceIds && search?.NewProvinceIds?.length > 0
                  ? "Không tìm thấy dữ liệu !"
                  : "Vui lòng chọn tỉnh/thành phố !"
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default AddressConversion;
